export function dispatchErrorsCleared(controller) {
    controller.dispatch("errorsCleared", { prefix: "" });
}
//# sourceMappingURL=errorscleared.js.map